import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import { OfferApprovalSettingsMessage } from '../../../../types/OfferApprovalSettingsMessage';
import { queries } from '../../../common/api/queryKeys/queries';

export const useOfferApprovalSettings: (
    offerId: string,
    enabled: boolean
) => QueryObserverResult<OfferApprovalSettingsMessage> = (offerId: string, enabled: boolean) => {
    return useQuery({
        ...queries.offers.detail(offerId)._ctx.approvalSettings,
        enabled,
    });
};
